import LinkIcon from "./LinkIcon";

const Sidebar = ({ sidebar, setSidebar }) => {
  // get the role from localStorage
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  // check base on the role what navigation bar you have
  const links = {
    Gerant: [
      { link: "/dashboard", text: "Tableau de bord" },
      { link: "/products", text: "Produits" },
      { link: "/real-indirect", text: "Effectif Réel Indirect" },
    ],
    developer: [
      { link: "/dashboard", text: "Tableau de bord" },
      { link: "/products", text: "Produits" },
      { link: "/users", text: "Utilisateurs" },
      { link: "/planning", text: "Planification" },
      { link: "/addconstantSystem", text: "constante système" },
      { link: "/direct", text: "Effectif standard direct" },
      { link: "/indirect", text: "Effectif Standard Indirect" },
      { link: "/chains", text: "Chaînes" },
      { link: "/posts", text: "Poste" },
      { link: "/real-direct", text: "Effectif Direct Réel" },
      { link: "/real-indirect", text: "Effectif Indirect Réel" },
      { link: "/real-fixe", text: "Effectif Réel Fixe" },
      { link: "/coupe", text: "Coupe" },
      { link: "/production_entre", text: "Production entrée" },
      { link: "/production_sortie", text: "Production Sortie" },
      { link: "/repassage", text: "Repassage" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: "/magasin", text: "Dépôt final" },
      { link: "/export", text: "Export" },
      { link: "/primes", text: "Primes" },
      { link: "/plastique_file", text: "Plastique and Fil" },
      { link: `/profile/${userId}`, text: "Profil" },
      { link: `/admin`, text: "Admin Page" },
    ],
    superadmin: [
      { link: "/dashboard", text: "Tableau de bord" },
      { link: "/products", text: "Produits" },
      { link: "/users", text: "Utilisateurs" },
      { link: "/planning", text: "Planification" },
      { link: "/addconstantSystem", text: "constante système" },
      { link: "/direct", text: "Effectif standard direct" },
      { link: "/indirect", text: "Effectif Standard Indirect" },
      { link: "/chains", text: "Chaînes" },
      { link: "/posts", text: "Poste" },
      { link: "/real-direct", text: "Effectif Direct Réel" },
      { link: "/real-indirect", text: "Effectif Indirect Réel" },
      { link: "/real-fixe", text: "Effectif Réel Fixe" },
      { link: "/coupe", text: "Coupe" },
      { link: "/production_entre", text: "Production entrée" },
      { link: "/production_sortie", text: "Production Sortie" },
      { link: "/repassage", text: "Repassage" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: "/magasin", text: "Dépôt final" },
      { link: "/export", text: "Export" },
      { link: "/primes", text: "Primes" },
      { link: "/plastique_file", text: "Plastique and Fil" },
      { link: `/profile/${userId}`, text: "Profil" },
      { link: `/admin`, text: "Admin Page" },
    ],
    admin: [
      { link: "/dashboard", text: "Tableau de bord" },
      { link: "/products", text: "Produits" },
      { link: "/users", text: "Utilisateurs" },
      { link: "/planning", text: "Planification" },
      { link: "/direct", text: "Effectif standard direct" },
      { link: "/indirect", text: "Effectif Standard Indirect" },
      { link: "/chains", text: "Chaînes" },
      { link: "/posts", text: "Poste" },
      { link: "/real-direct", text: "Effectif Direct Réel" },
      { link: "/real-indirect", text: "Effectif Indirect Réel" },
      { link: "/real-fixe", text: "Effectif Réel Fixe" },
      { link: "/coupe", text:  "Coupe" },
      { link: "/production_entre", text: "Production entrée" },
      { link: "/production_sortie", text: "Production Sortie" },
      { link: "/repassage", text: "Repassage" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: "/magasin", text: "Dépôt final" },
      { link: "/export", text: "Export" },
      { link: "/primes", text: "Primes" },
      { link: "/plastique_file", text: "Plastique and Fil" },
      { link: `/profile/${userId}`, text: "Profil" },
      { link: `/admin`, text: "Admin Page" },
    ],
    Logistique: [
      { link: "/products", text: "Produits" },
      { link: "/addproducts", text: "Ajouter un produit" },
      { link: "/export", text: "Export" },
      { link: `/profile/${userId}`, text: "Profil" },
   ],
    Méthode: [
      { link: "/products", text: "Produits" },
      { link: "/direct", text: "Effectif Standard Direct" },
      { link: "/indirect", text: "Effectif Standard Indirect" },
      { link: "/planning", text: "Planification" },
      { link: "/posts", text: "Posts" },
      { link: "/primes", text: "Primes" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    RH: [
      { link: "/products", text: "Produits" },
      { link: "/real-direct", text: "Effectif Direct Réel" },
      { link: "/real-indirect", text: "Effectif Indirect Réel" },
      { link: "/real-fixe", text: "Effectif Réel Fixe" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Production_coupe: [
      { link: "/products", text: "Produits" },
      { link: "/coupe", text: "La Coupe" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    manager: [
      { link: "/production_entre", text: "Production entrée" },
      { link: "/production_sortie", text: "Production Sortie" },
      { link: "/repassage", text: "Repassage" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: "/magasin", text: "Dépôt final" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Production_repassage: [
      { link: "/products", text: "Produits" },
      { link: "/repassage", text: "Repassage" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    "rep-cont": [
      { link: "/repassage", text: "Repassage" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Chaîne_production_entrée: [
      { link: "/products", text: "Produits" },
      { link: "/production_entre", text: "Production Entre" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Chaîne_production_sortie: [
      { link: "/products", text: "Produits" },
      { link: "/production_sortie", text: "Production Sortie" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Contrôle_final: [
      { link: "/products", text: "Produits" },
      { link: "/control-final", text: "Contrôle Final" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
    Magasin_final: [
      { link: "/products", text: "Produits" },
      { link: "/magasin", text: "Magasin" },
      { link: `/profile/${userId}`, text: "Profil" },
    ],
  };

  // render the links base on the logged in user
  const renderLinks = () => {
    const roleLinks = links[role] || [];
    return roleLinks.map((link, index) => (
      <LinkIcon key={index} link={link.link} text={link.text} />
    ));
  };

  return (
    <>
      {/* Mobile Overlay */}
      {sidebar && (
        <div 
          className="fixed inset-0 top-16 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebar(false)}
        />
      )}
      
      {/* Sidebar */}
      <div
        className={`w-[min(20rem,88vw)] lg:w-1/6 mt-16 lg:mt-20 bg-white fixed h-[calc(100dvh-4rem)] lg:h-[calc(100vh-5rem)] pb-20 lg:pb-[5rem] overflow-y-auto overscroll-contain z-50 transition-transform duration-300 ease-in-out
                ${
                  sidebar ? "left-0 shadow-2xl" : "left-[-100%]"
                } lg:left-0 lg:transform-none`}
        aria-label="Navigation principale"
      >
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Navigation</h2>
            <div className="w-12 h-1 bg-blue-600 rounded"></div>
          </div>
          <nav className="space-y-2">
            {renderLinks()}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
